import { getChertoBucketingId } from 'lib/experiments/chertoBucketingId'

/**
 * Cherto experiments to write after login rebucketing.
 *
 * A variant change must send a new activation. A resolved-unit change does too,
 * but only for Customer BK experiments: the same variant can move from no
 * customer id to the member id. Domain User ID experiments stay on the seed id
 * and are not re-fired when that visitor id changes. The shared unit map is
 * updated separately; this only returns the experiment rows whose enrolment
 * identity changed, with triggered cleared so the client sends again.
 */
export function getChertoRebucketExperiments(
  nextExperiments: Record<string, App.ChertoExperimentDetails | undefined>,
  previousExperiments: Record<string, App.ChertoExperimentDetails | undefined>,
  previousUnits: Readonly<Record<string, string>> | undefined,
  nextUnits: Readonly<Record<string, string>> | undefined,
): Record<string, App.ChertoExperimentDetails | undefined> {
  const experimentKeys = new Set([
    ...Object.keys(nextExperiments),
    ...Object.keys(previousExperiments),
  ])
  const experiments: Record<string, App.ChertoExperimentDetails | undefined> = {}

  experimentKeys.forEach(experimentKey => {
    const nextExperiment = nextExperiments[experimentKey]
    const previousExperiment = previousExperiments[experimentKey]
    if (!nextExperiment) {
      if (previousExperiment) {
        experiments[experimentKey] = undefined
      }
      return
    }

    const previousUnitId = getChertoBucketingId(previousUnits, experimentKey)
    const nextUnitId = getChertoBucketingId(nextUnits, experimentKey)
    const enrollmentChanged = !previousExperiment ||
      previousExperiment.variationKey !== nextExperiment.variationKey ||
      previousUnitId !== nextUnitId

    if (enrollmentChanged) {
      experiments[experimentKey] = { ...nextExperiment, triggered: false }
      return
    }

    if (previousExperiment.trackEnrollment !== nextExperiment.trackEnrollment) {
      experiments[experimentKey] = { ...nextExperiment, triggered: previousExperiment.triggered }
    }
  })

  return experiments
}
